import React, {
  useEffect,
  useMemo,
  useCallback,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import styles from "./UserProfile.module.css";

import NavSlider from "./NavSlider/NavSlider";
import LocationDrawer from "./UsersHomePages/LocationDrawer";

/* =========================================================
   CONSTRUCTION & BUILDING SERVICES
========================================================= */

const constructionWorks = [
  { id: 1, name: "Carpenter", icon: "🔨", link: "/serching_partner" },
  { id: 2, name: "Plumber", icon: "🔧", link: "/serching_partner" },
  { id: 3, name: "Electrician", icon: "🪜", link: "/serching_partner" },
  { id: 4, name: "Welder", icon: "👨‍🏭", link: "/serching_partner" },
  { id: 5, name: "Mason", icon: "👷", link: "/serching_partner" },
  { id: 6, name: "Tile Installer", icon: "🧱", link: "/serching_partner" },
  { id: 7, name: "Bricklayer", icon: "🏗️", link: "/serching_partner" },
  { id: 8, name: "Painter", icon: "🖌️", link: "/serching_partner" },
  { id: 9, name: "Ironworker", icon: "⚙️", link: "/serching_partner" },
  { id: 10, name: "Glass Installer", icon: "🪟", link: "/serching_partner" },
  { id: 11, name: "Roofing Technician", icon: "🏠", link: "/serching_partner" },
  { id: 12, name: "POP Worker", icon: "🏗️", link: "/serching_partner" },
  { id: 13, name: "False Ceiling Worker", icon: "🔨", link: "/serching_partner" },
  { id: 14, name: "Interior Worker", icon: "🏠", link: "/serching_partner" },
  { id: 15, name: "Exterior Worker", icon: "🏢", link: "/serching_partner" },
  { id: 16, name: "Flooring Installer", icon: "🧱", link: "/serching_partner" },
  { id: 17, name: "Marble Worker", icon: "⬜", link: "/serching_partner" },
  { id: 18, name: "Granite Worker", icon: "🪨", link: "/serching_partner" },
  { id: 19, name: "Waterproofing Technician", icon: "💧", link: "/serching_partner" },
  { id: 20, name: "Demolition Worker", icon: "🏚️", link: "/serching_partner" },
  { id: 21, name: "Construction Helper", icon: "👷", link: "/serching_partner" },
  { id: 22, name: "Scaffolding Worker", icon: "🏗️", link: "/serching_partner" }
];

/* =========================================================
   HOUSEHOLD SERVICES
========================================================= */

const householdWorks = [
  { id: 1, name: "Atta Chakki", icon: "🌾" },
  { id: 2, name: "Maid", icon: "🧹" },
  { id: 3, name: "Ironer", icon: "👔" },
  { id: 4, name: "Milkman", icon: "🥛" },
  { id: 5, name: "Home Cook", icon: "🍳" },
  { id: 6, name: "Gardener", icon: "🪴" },
  { id: 7, name: "Pet Sitter", icon: "🐕" },
  { id: 8, name: "Car Washer", icon: "🚗" },
  { id: 9, name: "Day Driver", icon: "🚘" },
  { id: 10, name: "Housekeeper", icon: "🧹" },
  { id: 11, name: "Baby Sitter", icon: "👶" },
  { id: 12, name: "Elder Care Helper", icon: "👴" },
  { id: 13, name: "Kitchen Helper", icon: "🍽️" },
  { id: 14, name: "House Cleaning Worker", icon: "🧽" },
  { id: 15, name: "Deep Cleaning Worker", icon: "✨" },
  { id: 16, name: "Laundry Worker", icon: "👕" },
  { id: 17, name: "Home Organizer", icon: "📦" }
];

/* =========================================================
   ELECTRICAL TRADES
========================================================= */

const electricalWorks = [
  { id: 1, name: "Electrician", icon: "⚡" },
  { id: 2, name: "Electrical Contractor", icon: "🔌" },
  { id: 3, name: "AC Technician", icon: "❄️" },
  { id: 4, name: "CCTV Installer", icon: "📹" },
  { id: 5, name: "Solar Installer", icon: "☀️" },
  { id: 6, name: "Inverter Technician", icon: "🔋" },
  { id: 7, name: "Generator Technician", icon: "⚙️" },
  { id: 8, name: "Fan Repair Technician", icon: "🌀" },
  { id: 9, name: "Switchboard Technician", icon: "🔌" },
  { id: 10, name: "Wiring Technician", icon: "🪛" },
  { id: 11, name: "Lift Technician", icon: "🛗" },
  { id: 12, name: "Fire Alarm Technician", icon: "🚨" },
  { id: 13, name: "Home Automation Technician", icon: "🏠" },
  { id: 14, name: "Battery Technician", icon: "🔋" }
];

/* =========================================================
   MECHANICAL TRADES
========================================================= */

const mechanicalWorks = [
  { id: 1, name: "Mechanic", icon: "🔧" },
  { id: 2, name: "Auto Mechanic", icon: "🚗" },
  { id: 3, name: "Bike Mechanic", icon: "🏍️" },
  { id: 4, name: "Diesel Mechanic", icon: "⚙️" },
  { id: 5, name: "Machine Operator", icon: "⚙️" },
  { id: 6, name: "Lathe Machine Operator", icon: "🔩" },
  { id: 7, name: "CNC Operator", icon: "🖥️" },
  { id: 8, name: "Fitter", icon: "🔧" },
  { id: 9, name: "Fabricator", icon: "🛠️" },
  { id: 10, name: "Machinist", icon: "⚙️" },
  { id: 11, name: "Hydraulic Technician", icon: "🔩" },
  { id: 12, name: "Pump Technician", icon: "💧" },
  { id: 13, name: "Compressor Technician", icon: "⚙️" },
  { id: 14, name: "Industrial Technician", icon: "🏭" },
  { id: 15, name: "Welding Technician", icon: "👨‍🏭" }
];

/* =========================================================
   EVENT & HOSPITALITY TRADES
========================================================= */

const eventHospitalityWorks = [
  { id: 1, name: "Event Planner", icon: "📋" },
  { id: 2, name: "Event Manager", icon: "🎪" },
  { id: 3, name: "Caterer", icon: "🍽️" },
  { id: 4, name: "Chef", icon: "👨‍🍳" },
  { id: 5, name: "Waiter", icon: "🍴" },
  { id: 6, name: "Bartender", icon: "🍹" },
  { id: 7, name: "Kitchen Staff", icon: "👨‍🍳" },
  { id: 8, name: "Hotel Staff", icon: "🏨" },
  { id: 9, name: "Receptionist", icon: "🛎️" },
  { id: 10, name: "Housekeeping Staff", icon: "🧹" },
  { id: 11, name: "Decoration Worker", icon: "🎈" },
  { id: 12, name: "DJ Operator", icon: "🎧" },
  { id: 13, name: "Sound Technician", icon: "🔊" },
  { id: 14, name: "Lighting Technician", icon: "💡" },
  { id: 15, name: "Event Photographer", icon: "📸" },
  { id: 16, name: "Event Videographer", icon: "🎥" }
];

/* =========================================================
   TRANSPORTATION & LOGISTICS TRADES
========================================================= */

const transportationLogisticsWorks = [
  { id: 1, name: "Car Driver", icon: "🚗" },
  { id: 2, name: "Taxi Driver", icon: "🚕" },
  { id: 3, name: "Truck Driver", icon: "🚛" },
  { id: 4, name: "Bus Driver", icon: "🚌" },
  { id: 5, name: "Auto Driver", icon: "🛺" },
  { id: 6, name: "Delivery Driver", icon: "📦" },
  { id: 7, name: "Courier Agent", icon: "📨" },
  { id: 8, name: "Bike Delivery Rider", icon: "🏍️" },
  { id: 9, name: "Warehouse Worker", icon: "🏭" },
  { id: 10, name: "Loader", icon: "📦" },
  { id: 11, name: "Unloader", icon: "📦" },
  { id: 12, name: "Forklift Operator", icon: "🚜" },
  { id: 13, name: "Logistics Assistant", icon: "🚚" },
  { id: 14, name: "Packager", icon: "📦" },
  { id: 15, name: "Moving Helper", icon: "🏠" }
];

/* =========================================================
   HEALTHCARE / MEDICAL TRADES
========================================================= */

const healthcareMedicalWorks = [
  { id: 1, name: "Nurse", icon: "👩‍⚕️" },
  { id: 2, name: "Caregiver", icon: "🧑‍⚕️" },
  { id: 3, name: "Medical Assistant", icon: "🩺" },
  { id: 4, name: "Pharmacist", icon: "💊" },
  { id: 5, name: "Lab Technician", icon: "🧪" },
  { id: 6, name: "Physiotherapist", icon: "🏃" },
  { id: 7, name: "Dental Assistant", icon: "🦷" },
  { id: 8, name: "Optical Technician", icon: "👓" },
  { id: 9, name: "Medical Attendant", icon: "🏥" },
  { id: 10, name: "Home Healthcare Worker", icon: "🏠" },
  { id: 11, name: "Patient Care Assistant", icon: "🧑‍⚕️" },
  { id: 12, name: "Ambulance Driver", icon: "🚑" }
];

/* =========================================================
   BEAUTY & WELLNESS TRADES
========================================================= */

const beautyWellnessWorks = [
  { id: 1, name: "Hair Stylist", icon: "💇" },
  { id: 2, name: "Barber", icon: "💈" },
  { id: 3, name: "Beautician", icon: "💄" },
  { id: 4, name: "Makeup Artist", icon: "💋" },
  { id: 5, name: "Mehndi Artist", icon: "🤲" },
  { id: 6, name: "Nail Technician", icon: "💅" },
  { id: 7, name: "Skin Care Specialist", icon: "✨" },
  { id: 8, name: "Massage Therapist", icon: "💆" },
  { id: 9, name: "Spa Therapist", icon: "🧖" },
  { id: 10, name: "Yoga Instructor", icon: "🧘" },
  { id: 11, name: "Wellness Coach", icon: "🌿" },
  { id: 12, name: "Personal Groomer", icon: "🪞" }
];

/* =========================================================
   SKILLED CRAFTS
========================================================= */

const skilledCraftsWorks = [
  { id: 1, name: "Handicraft Worker", icon: "🧶" },
  { id: 2, name: "Potter", icon: "🏺" },
  { id: 3, name: "Wood Carver", icon: "🪵" },
  { id: 4, name: "Sculptor", icon: "🗿" },
  { id: 5, name: "Jewellery Maker", icon: "💎" },
  { id: 6, name: "Goldsmith", icon: "💍" },
  { id: 7, name: "Silversmith", icon: "🥈" },
  { id: 8, name: "Leather Worker", icon: "👜" },
  { id: 9, name: "Candle Maker", icon: "🕯️" },
  { id: 10, name: "Artisan", icon: "🎨" },
  { id: 11, name: "Picture Framer", icon: "🖼️" },
  { id: 12, name: "Key Maker", icon: "🔑" }
];

/* =========================================================
   LANDSCAPING & GARDENING TRADES
========================================================= */

const landscapingGardeningWorks = [
  { id: 1, name: "Gardener", icon: "🌱" },
  { id: 2, name: "Landscape Designer", icon: "🌳" },
  { id: 3, name: "Landscape Worker", icon: "🌿" },
  { id: 4, name: "Tree Trimmer", icon: "🌳" },
  { id: 5, name: "Tree Cutter", icon: "🪚" },
  { id: 6, name: "Lawn Care Worker", icon: "🌱" },
  { id: 7, name: "Plant Care Worker", icon: "🪴" },
  { id: 8, name: "Nursery Worker", icon: "🌱" },
  { id: 9, name: "Irrigation Worker", icon: "💧" },
  { id: 10, name: "Garden Cleaner", icon: "🧹" },
  { id: 11, name: "Pesticide Applicator", icon: "🌿" },
  { id: 12, name: "Garden Maintenance Worker", icon: "🌳" }
];

/* =========================================================
   REPAIR & MAINTENANCE TRADES
========================================================= */

const repairMaintenanceWorks = [
  { id: 1, name: "Appliance Repair Technician", icon: "🔧" },
  { id: 2, name: "Refrigerator Technician", icon: "🧊" },
  { id: 3, name: "Washing Machine Technician", icon: "🧺" },
  { id: 4, name: "Microwave Repair Technician", icon: "📻" },
  { id: 5, name: "TV Repair Technician", icon: "📺" },
  { id: 6, name: "Mobile Repair Technician", icon: "📱" },
  { id: 7, name: "Computer Repair Technician", icon: "💻" },
  { id: 8, name: "Laptop Repair Technician", icon: "💻" },
  { id: 9, name: "Printer Repair Technician", icon: "🖨️" },
  { id: 10, name: "AC Repair Technician", icon: "❄️" },
  { id: 11, name: "RO Water Purifier Technician", icon: "💧" },
  { id: 12, name: "Chimney Repair Technician", icon: "🏠" },
  { id: 13, name: "Geyser Technician", icon: "♨️" },
  { id: 14, name: "Locksmith", icon: "🔐" },
  { id: 15, name: "Shoe Repair Worker", icon: "👞" }
];

/* =========================================================
   TEXTILE & APPAREL TRADES
========================================================= */

const textileApparelWorks = [
  { id: 1, name: "Tailor", icon: "🧵" },
  { id: 2, name: "Dress Maker", icon: "👗" },
  { id: 3, name: "Embroidery Worker", icon: "🧵" },
  { id: 4, name: "Hand Embroidery Artist", icon: "🪡" },
  { id: 5, name: "Saree Draper", icon: "🥻" },
  { id: 6, name: "Alteration Specialist", icon: "✂️" },
  { id: 7, name: "Garment Worker", icon: "👕" },
  { id: 8, name: "Fabric Cutter", icon: "✂️" },
  { id: 9, name: "Sewing Machine Operator", icon: "🧵" },
  { id: 10, name: "Textile Worker", icon: "🧶" },
  { id: 11, name: "Dyer", icon: "🎨" },
  { id: 12, name: "Clothing Designer", icon: "👚" }
];

/* =========================================================
   ENERGY & UTILITIES
========================================================= */

const energyUtilitiesWorks = [
  { id: 1, name: "Solar Technician", icon: "☀️" },
  { id: 2, name: "Solar Panel Installer", icon: "🔆" },
  { id: 3, name: "Solar Maintenance Technician", icon: "🔧" },
  { id: 4, name: "Battery Technician", icon: "🔋" },
  { id: 5, name: "Inverter Technician", icon: "🔋" },
  { id: 6, name: "Generator Technician", icon: "⚙️" },
  { id: 7, name: "Power Backup Technician", icon: "⚡" },
  { id: 8, name: "Water Pump Technician", icon: "💧" },
  { id: 9, name: "Water Tank Cleaner", icon: "🚰" },
  { id: 10, name: "Water Purifier Technician", icon: "💧" },
  { id: 11, name: "Gas Pipeline Technician", icon: "🔥" },
  { id: 12, name: "Utility Maintenance Worker", icon: "🛠️" }
];

/* =========================================================
   SECURITY & PROTECTIVE SERVICES
========================================================= */

const securityProtectiveWorks = [
  { id: 1, name: "Security Guard", icon: "🛡️" },
  { id: 2, name: "Watchman", icon: "👮" },
  { id: 3, name: "Bouncer", icon: "🧍" },
  { id: 4, name: "Security Supervisor", icon: "🛡️" },
  { id: 5, name: "Event Security", icon: "🎫" },
  { id: 6, name: "Gatekeeper", icon: "🚪" },
  { id: 7, name: "CCTV Security Operator", icon: "📹" },
  { id: 8, name: "Security System Installer", icon: "🔐" },
  { id: 9, name: "Fire Safety Worker", icon: "🧯" },
  { id: 10, name: "Safety Supervisor", icon: "⛑️" }
];

/* =========================================================
   SPORTS & FITNESS TRADES
========================================================= */

const sportsFitnessWorks = [
  { id: 1, name: "Personal Trainer", icon: "🏋️" },
  { id: 2, name: "Fitness Trainer", icon: "💪" },
  { id: 3, name: "Gym Trainer", icon: "🏋️" },
  { id: 4, name: "Yoga Instructor", icon: "🧘" },
  { id: 5, name: "Sports Coach", icon: "🏆" },
  { id: 6, name: "Cricket Coach", icon: "🏏" },
  { id: 7, name: "Football Coach", icon: "⚽" },
  { id: 8, name: "Swimming Coach", icon: "🏊" },
  { id: 9, name: "Badminton Coach", icon: "🏸" },
  { id: 10, name: "Dance Trainer", icon: "💃" },
  { id: 11, name: "Athletic Trainer", icon: "🏃" },
  { id: 12, name: "Fitness Instructor", icon: "🤸" }
];

/* =========================================================
   SANITARY & DISPOSAL SERVICES
========================================================= */

const sanitaryDisposalWorks = [
  { id: 1, name: "Sanitary Worker", icon: "🧹" },
  { id: 2, name: "Drainage Cleaner", icon: "🚰" },
  { id: 3, name: "Sewer Cleaner", icon: "🛠️" },
  { id: 4, name: "Septic Tank Cleaner", icon: "🚛" },
  { id: 5, name: "Toilet Cleaner", icon: "🚽" },
  { id: 6, name: "Bathroom Cleaner", icon: "🧽" },
  { id: 7, name: "Waste Collector", icon: "♻️" },
  { id: 8, name: "Garbage Collector", icon: "🗑️" },
  { id: 9, name: "Recycling Worker", icon: "♻️" },
  { id: 10, name: "Pest Control Worker", icon: "🐜" },
  { id: 11, name: "Disinfection Worker", icon: "🧴" },
  { id: 12, name: "Fumigation Worker", icon: "🦟" }
];

/* =========================================================
   ALL WORK CATEGORIES
========================================================= */

const allWorkCategories = [
  {
    id: 1,
    name: "CONSTRUCTION & BUILDING",
    accent: "orange",
    works: constructionWorks
  },
  {
    id: 2,
    name: "HOUSEHOLD SERVICES",
    accent: "blue",
    works: householdWorks
  },
  {
    id: 3,
    name: "ELECTRICAL TRADES",
    accent: "yellow",
    works: electricalWorks
  },
  {
    id: 4,
    name: "MECHANICAL TRADES",
    accent: "gray",
    works: mechanicalWorks
  },
  {
    id: 5,
    name: "EVENT & HOSPITALITY TRADES",
    accent: "pink",
    works: eventHospitalityWorks
  },
  {
    id: 6,
    name: "TRANSPORTATION & LOGISTICS",
    accent: "green",
    works: transportationLogisticsWorks
  },
  {
    id: 7,
    name: "HEALTHCARE & MEDICAL TRADES",
    accent: "red",
    works: healthcareMedicalWorks
  },
  {
    id: 8,
    name: "BEAUTY & WELLNESS TRADES",
    accent: "purple",
    works: beautyWellnessWorks
  },
  {
    id: 9,
    name: "SKILLED CRAFTS",
    accent: "brown",
    works: skilledCraftsWorks
  },
  {
    id: 10,
    name: "LANDSCAPING & GARDENING",
    accent: "light-green",
    works: landscapingGardeningWorks
  },
  {
    id: 11,
    name: "REPAIR & MAINTENANCE",
    accent: "dark-blue",
    works: repairMaintenanceWorks
  },
  {
    id: 12,
    name: "TEXTILE & APPAREL TRADES",
    accent: "rose",
    works: textileApparelWorks
  },
  {
    id: 13,
    name: "ENERGY & UTILITIES",
    accent: "cyan",
    works: energyUtilitiesWorks
  },
  {
    id: 14,
    name: "SECURITY & PROTECTIVE SERVICES",
    accent: "navy",
    works: securityProtectiveWorks
  },
  {
    id: 15,
    name: "SPORTS & FITNESS TRADES",
    accent: "lime",
    works: sportsFitnessWorks
  },
  {
    id: 16,
    name: "SANITARY & DISPOSAL SERVICES",
    accent: "teal",
    works: sanitaryDisposalWorks
  }
];

/* =========================================================
   USER PROFILE
========================================================= */

export default function UserProfile() {

  const navigate = useNavigate();

  /* =======================================================
     URL PARAMETERS
  ======================================================= */

  const { userId, deviceUuid } = useParams();

  /* =======================================================
     ADDRESS UPDATE CODE
  ======================================================= */

  const API_BASE = "https://coinyoco.world/brobizee-api";
  const UPDATE_ADDRESS_API = `${API_BASE}/update_address.php`;

  const [currentAddress, setCurrentAddress] = useState(
    localStorage.getItem("user_address") || ""
  );

  /* =========================================================
     AUTO UPDATE ADDRESS EVERY 2 MINUTES
  ========================================================= */

  useEffect(() => {
    const updateAddress = () => {
      if (!userId || !deviceUuid) return;
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`
            );

            if (!response.ok) return;

            const data = await response.json();
            if (!data.display_name) return;

            const newAddress = data.display_name;

            setCurrentAddress(newAddress);
            localStorage.setItem("user_address", newAddress);
            localStorage.setItem("current_latitude", String(latitude));
            localStorage.setItem("current_longitude", String(longitude));
            localStorage.setItem(
              "current_latitude_longitude",
              `${latitude},${longitude}`
            );

            const formData = new FormData();
            formData.append("user_id", String(userId));
            formData.append("device_uuid", String(deviceUuid));
            formData.append("location_live", newAddress);

            await fetch(UPDATE_ADDRESS_API, {
              method: "POST",
              body: formData
            });

            console.log("Address updated:", newAddress);
          } catch (error) {
            console.error("Address update error:", error);
          }
        },
        (error) => {
          console.log("Location error:", error);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0
        }
      );
    };

    updateAddress();

    const timer = setInterval(updateAddress, 120000);

    return () => clearInterval(timer);
  }, [userId, deviceUuid]);

  /* =======================================================
     BASE PATH
  ======================================================= */

  const basePath = `/${userId}/${deviceUuid}`;

  /* =======================================================
     SEARCH
  ======================================================= */

  const [searchTerm, setSearchTerm] = useState("");

  /* =======================================================
     TRENDING / CATEGORY
     false = TRENDING
     true  = BY CATEGORY
  ======================================================= */

  const [byCategory, setByCategory] = useState(false);

  /* =======================================================
     BOTTOM NAV
  ======================================================= */

  const [activeTab, setActiveTab] = useState("home");

  /* =======================================================
     MENU DRAWER
  ======================================================= */

  const [menuOpen, setMenuOpen] = useState(false);

  /* =======================================================
     LOCATION DRAWER
  ======================================================= */

  const [locationOpen, setLocationOpen] = useState(false);

  /* =======================================================
     LIVE LOCATION STATE
  ======================================================= */

  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* =======================================================
     LOAD SAVED LOCATION
  ======================================================= */

  useEffect(() => {
    const savedLocation = localStorage.getItem("live_location");
    if (!savedLocation) return;

    try {
      const locationData = JSON.parse(savedLocation);
      if (locationData && locationData.address) {
        setCurrentAddress(locationData.address);
      }
    } catch (error) {
      console.error("Saved location parse error:", error);
    }
  }, []);

  /* =======================================================
     SEARCH - TRENDING CONSTRUCTION
  ======================================================= */

  const filteredConstruction = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();
    if (!search) return constructionWorks;

    return constructionWorks.filter((item) =>
      item.name.toLowerCase().includes(search)
    );
  }, [searchTerm]);

  /* =======================================================
     SEARCH - TRENDING HOUSEHOLD
  ======================================================= */

  const filteredHousehold = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();
    if (!search) return householdWorks;

    return householdWorks.filter((item) =>
      item.name.toLowerCase().includes(search)
    );
  }, [searchTerm]);

  /* =======================================================
     SEARCH - ALL BY CATEGORY
  ======================================================= */

  const filteredCategories = useMemo(() => {
    const search = searchTerm.trim().toLowerCase();

    return allWorkCategories
      .map((category) => {
        const filteredWorks = search
          ? category.works.filter((item) =>
              item.name.toLowerCase().includes(search)
            )
          : category.works;

        return {
          ...category,
          works: filteredWorks
        };
      })
      .filter((category) => category.works.length > 0);
  }, [searchTerm]);

  /* =======================================================
     SERVICE CLICK
  ======================================================= */

  const handleServiceClick = useCallback(
    (service) => {
      console.log("Selected Service:", service);

      const selectedServiceName = service?.name || "Carpenter";
      const selectedServiceIcon = service?.icon || "";
      const selectedCategoryId = service?.categoryId || null;
      const selectedCategoryName = service?.categoryName || "";

      localStorage.setItem("selected_service_name", selectedServiceName);
      localStorage.setItem("selected_service_icon", selectedServiceIcon);
      localStorage.setItem(
        "selected_service_category_id",
        String(selectedCategoryId || "")
      );
      localStorage.setItem(
        "selected_service_category_name",
        selectedCategoryName
      );

      navigate(`/${userId}/${deviceUuid}/serching_partner`, {
        state: {
          serviceName: selectedServiceName,
          serviceIcon: selectedServiceIcon,
          categoryId: selectedCategoryId,
          categoryName: selectedCategoryName,
          userId: userId,
          deviceUuid: deviceUuid
        }
      });
    },
    [navigate, userId, deviceUuid]
  );

  /* =======================================================
     HEADER - NOTIFICATION
  ======================================================= */

  const handleNotification = () => {
    navigate(`${basePath}/notification`);
  };

  /* =======================================================
     HEADER - ID CARD
  ======================================================= */

  const handleIdCard = () => {
    console.log("ID Card clicked");
  };

  /* =======================================================
     HEADER - MENU
  ======================================================= */

  const handleMenu = () => {
    setMenuOpen(true);
  };

  /* =======================================================
     LOCATION
  ======================================================= */

  const handleLocationClick = () => {
    setLocationOpen(true);
  };

  /* =======================================================
     MORE CATEGORY
  ======================================================= */

  const handleMoreCategory = (category) => {
    console.log("More category:", category);
  };

  /* =======================================================
     TOGGLE
  ======================================================= */

  const handleToggle = () => {
    setByCategory((previous) => !previous);
  };

  /* =======================================================
     NAVIGATION HELPER
  ======================================================= */

  const goTo = (page) => {
    navigate(`${basePath}/${page}`);
  };

  /* =======================================================
     LIVE LOCATION
  ======================================================= */

  const getLiveLocation = () => {
    setError("");
    setLocation("");

    if (!navigator.geolocation) {
      setError("Your browser does not support location.");
      return;
    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        console.log("Latitude:", latitude);
        console.log("Longitude:", longitude);

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
          );

          if (!response.ok) {
            throw new Error("Address API failed");
          }

          const data = await response.json();
          console.log("Location Data:", data);

          if (data && data.display_name) {
            const address = data.display_name;

            setLocation(address);
            setCurrentAddress(address);
            localStorage.setItem("user_address", address);
            localStorage.setItem("current_latitude", String(latitude));
            localStorage.setItem("current_longitude", String(longitude));
            localStorage.setItem(
              "current_latitude_longitude",
              `${latitude},${longitude}`
            );
          } else {
            setError("Address not found.");
          }
        } catch (err) {
          console.error(err);
          setError("Unable to find your address.");
        } finally {
          setLoading(false);
        }
      },
      (geoError) => {
        console.error("Location Error:", geoError);
        setLoading(false);

        if (geoError.code === 1) {
          setError(
            "Location permission denied. Please allow location."
          );
        } else if (geoError.code === 2) {
          setError("Your location could not be determined.");
        } else if (geoError.code === 3) {
          setError("Location request timed out.");
        } else {
          setError("Unable to get your location.");
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    );
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className={styles.userProfileWrapper}>
      {/* ===================================================
          NAV SLIDER
      =================================================== */}

      <NavSlider
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        navigate={navigate}
      />

      {/* ===================================================
          LOCATION DRAWER
      =================================================== */}

      <LocationDrawer
        isOpen={locationOpen}
        onClose={() => setLocationOpen(false)}
        onLocationSelect={(locationData) => {
          console.log("Selected live location:", locationData);

          if (locationData && locationData.address) {
            setCurrentAddress(locationData.address);
            localStorage.setItem("user_address", locationData.address);
          }
        }}
        navigate={navigate}
      />

      {/* ===================================================
          USER PROFILE CARD
      =================================================== */}

      <div className={styles.userProfileCard}>
        {/* =================================================
            HEADER
        ================================================= */}

        <header className={styles.profileHeader}>
          {/* =================================================
              HEADER TOP
          ================================================= */}

          <div className={styles.headerTopBar}>
            {/* BRAND */}

            <div className={styles.brandTitle}>
              <span className={styles.brandLets}>Let's</span>
              <br />
              <span className={styles.brandBro}>Bro</span>
              <span className={styles.brandBizee}>Bizee</span>
            </div>

            {/* =================================================
                HEADER ACTIONS
            ================================================= */}

            <div className={styles.headerActions}>
              {/* NOTIFICATION */}

              <button
                type="button"
                className={styles.headerIconBtn}
                aria-label="Notifications"
                onClick={handleNotification}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
              </button>

              {/* ID CARD */}

              <button
                type="button"
                className={styles.headerIconBtn}
                aria-label="ID Card"
                onClick={handleIdCard}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="16" rx="3" />
                  <circle cx="9" cy="10" r="2" />
                  <path d="M15 8h2" />
                  <path d="M15 12h2" />
                  <path d="M7 16h10" />
                </svg>
              </button>

              {/* MENU */}

              <button
                type="button"
                className={styles.headerIconBtn}
                aria-label="Menu"
                onClick={handleMenu}
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.3"
                  strokeLinecap="round"
                >
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
            </div>
          </div>

          {/* =================================================
              SEARCH
          ================================================= */}

          <div className={styles.searchBarContainer}>
            {/* SEARCH ICON */}

            <svg
              className={styles.searchIcon}
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>

            {/* SEARCH INPUT */}

            <input
              type="text"
              placeholder="Search services, workers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />

            {/* CLEAR SEARCH */}

            {searchTerm && (
              <button
                type="button"
                className={styles.clearSearchBtn}
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ×
              </button>
            )}

            {/* MICROPHONE */}

            <button
              type="button"
              className={styles.micBtn}
              aria-label="Voice Search"
              onClick={() => console.log("Voice search")}
            >
              <svg
                className={styles.micIcon}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
              >
                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                <line x1="12" y1="19" x2="12" y2="23" />
              </svg>
            </button>
          </div>

          {/* =================================================
              SEARCH RESULT LABEL
          ================================================= */}

          {searchTerm && (
            <div className={styles.searchResultLabel}>
              Search results for{" "}
              <strong>"{searchTerm}"</strong>
            </div>
          )}

          {/* =================================================
              LOCATION
          ================================================= */}

          <button
            type="button"
            className={styles.locationPicker}
            onClick={handleLocationClick}
          >
            <span className={styles.locationIcon}>
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </span>

            <span className={styles.locationTextWrapper}>
              <span
                className={currentAddress ? styles.locationMarquee : ""}
              >
                {currentAddress ||
                  "Select location to discover near work"}
              </span>
            </span>

            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {/* =================================================
              TRENDING / BY CATEGORY TOGGLE
          ================================================= */}

          <div className={styles.filterToggleRow}>
            <label className={styles.toggleSwitch}>
              <input
                type="checkbox"
                checked={byCategory}
                onChange={handleToggle}
              />
              <span className={styles.slider + " " + styles.round}></span>
            </label>

            <span className={styles.filterLabel}>
              {byCategory ? "BY CATEGORY" : "TRENDING"}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <polygon points="12 2 2 7 12 12 22 7 12 2" />
              <polyline points="2 17 12 22 22 17" />
              <polyline points="2 12 12 17 22 12" />
            </svg>
          </div>
        </header>

        {/* ===================================================
            SCROLL BODY
        =================================================== */}

        <main className={styles.profileScrollBody}>
          {/* =================================================
              TRENDING - CONSTRUCTION
          ================================================= */}

          {!byCategory && filteredConstruction.length > 0 && (
            <section className={styles.categorySection}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionTitleWrap}>
                  <span className={styles.sectionAccent}></span>
                  <h2 className={styles.categoryTitle}>
                    CONSTRUCTION & BUILDING
                  </h2>
                </div>

                <span className={styles.badge}>
                  {filteredConstruction.length}
                </span>
              </div>

              <div className={styles.categoryCard}>
                <div className={styles.servicesGrid}>
                  {filteredConstruction.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className={styles.serviceItem}
                      onClick={() =>
                        handleServiceClick({
                          ...item,
                          categoryId: 1,
                          categoryName: "CONSTRUCTION & BUILDING"
                        })
                      }
                    >
                      <div className={styles.serviceIconWrapper}>
                        <span className={styles.serviceIcon}>
                          {item.icon}
                        </span>
                      </div>

                      <span className={styles.serviceName}>
                        {item.name}
                      </span>
                    </button>
                  ))}

                  {!searchTerm && (
                    <button
                      type="button"
                      className={styles.nextArrowBtn}
                      aria-label="More Construction Services"
                      onClick={() =>
                        handleMoreCategory({
                          id: 1,
                          name: "CONSTRUCTION & BUILDING",
                          works: constructionWorks
                        })
                      }
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </section>
          )}

          {/* =================================================
              TRENDING - HOUSEHOLD
          ================================================= */}

          {!byCategory && filteredHousehold.length > 0 && (
            <section className={styles.categorySection}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionTitleWrap}>
                  <span
                    className={
                      styles.sectionAccent + " " + styles.blueAccent
                    }
                  ></span>
                  <h2 className={styles.categoryTitle}>
                    HOUSEHOLD SERVICES
                  </h2>
                </div>

                <span className={styles.badge}>
                  {filteredHousehold.length}
                </span>
              </div>

              <div className={styles.categoryCard}>
                <div className={styles.servicesGrid}>
                  {filteredHousehold.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      className={styles.serviceItem}
                      onClick={() =>
                        handleServiceClick({
                          ...item,
                          categoryId: 2,
                          categoryName: "HOUSEHOLD SERVICES"
                        })
                      }
                    >
                      <div className={styles.serviceIconWrapper}>
                        <span className={styles.serviceIcon}>
                          {item.icon}
                        </span>
                      </div>

                      <span className={styles.serviceName}>
                        {item.name}
                      </span>
                    </button>
                  ))}

                  {!searchTerm && (
                    <button
                      type="button"
                      className={styles.nextArrowBtn}
                      aria-label="More Household Services"
                      onClick={() =>
                        handleMoreCategory({
                          id: 2,
                          name: "HOUSEHOLD SERVICES",
                          works: householdWorks
                        })
                      }
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </section>
          )}

          {/* =================================================
              BY CATEGORY - ALL CATEGORIES
          ================================================= */}

          {byCategory && filteredCategories.length > 0 && (
            <>
              {filteredCategories.map((category) => (
                <section
                  className={styles.categorySection}
                  key={category.id}
                >
                  {/* CATEGORY HEADER */}

                  <div className={styles.sectionHeader}>
                    <div className={styles.sectionTitleWrap}>
                      <span
                        className={
                          styles.sectionAccent +
                          " " +
                          styles[`${category.accent}-accent`]
                        }
                      ></span>
                      <h2 className={styles.categoryTitle}>
                        {category.name}
                      </h2>
                    </div>

                    <span className={styles.badge}>
                      {category.works.length}
                    </span>
                  </div>

                  {/* CATEGORY CARD */}

                  <div className={styles.categoryCard}>
                    <div className={styles.servicesGrid}>
                      {category.works.map((item) => (
                        <button
                          key={`${category.id}-${item.id}`}
                          type="button"
                          className={styles.serviceItem}
                          onClick={() =>
                            handleServiceClick({
                              ...item,
                              categoryId: category.id,
                              categoryName: category.name
                            })
                          }
                        >
                          <div className={styles.serviceIconWrapper}>
                            <span className={styles.serviceIcon}>
                              {item.icon}
                            </span>
                          </div>

                          <span className={styles.serviceName}>
                            {item.name}
                          </span>
                        </button>
                      ))}

                      {!searchTerm && (
                        <button
                          type="button"
                          className={styles.nextArrowBtn}
                          aria-label={`More ${category.name}`}
                          onClick={() => handleMoreCategory(category)}
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="9 18 15 12 9 6" />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                </section>
              ))}
            </>
          )}

          {/* =================================================
              NO RESULTS - TRENDING
          ================================================= */}

          {!byCategory &&
            filteredConstruction.length === 0 &&
            filteredHousehold.length === 0 && (
              <div className={styles.noResults}>
                <div className={styles.noResultsIcon}>🔍</div>

                <h3>No services found</h3>
                <p>Try searching for another service.</p>
              </div>
            )}

          {/* =================================================
              NO RESULTS - BY CATEGORY
          ================================================= */}

          {byCategory && filteredCategories.length === 0 && (
            <div className={styles.noResults}>
              <div className={styles.noResultsIcon}>🔍</div>

              <h3>No services found</h3>
              <p>Try searching for another service.</p>
            </div>
          )}

          {/* =================================================
              BOTTOM SPACE
          ================================================= */}

          <div className={styles.scrollBottomSpace}></div>
        </main>

        {/* ===================================================
            BOTTOM NAVIGATION
        =================================================== */}

        <div className={styles.bottomNavWrapper}>
          <nav className={styles.bottomNav} aria-label="Bottom Navigation">
            {/* HOME */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeTab === "home" ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab("home");
                goTo("userprofile");
              }}
              aria-label="Home"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>

              <span className={styles.navLabel}>Home</span>
            </button>

            {/* SEARCH */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeTab === "search" ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab("search");
                goTo("search");
              }}
              aria-label="Search"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>

              <span className={styles.navLabel}>Search</span>
            </button>

            {/* TASKS */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeTab === "clipboard" ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab("clipboard");
                goTo("tasks");
              }}
              aria-label="Tasks"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <rect x="8" y="2" width="8" height="4" rx="1" />
                <path d="M8 11h8" />
                <path d="M8 15h5" />
              </svg>

              <span className={styles.navLabel}>Tasks</span>
            </button>

            {/* MEDIA */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeTab === "media" ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab("media");
                goTo("media");
              }}
              aria-label="Media"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>

              <span className={styles.navLabel}>Media</span>
            </button>

            {/* WALLET */}

            <button
              type="button"
              className={`${styles.navBtn} ${
                activeTab === "wallet" ? styles.active : ""
              }`}
              onClick={() => {
                setActiveTab("wallet");
                goTo("wallet");
              }}
              aria-label="Wallet"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="6" width="20" height="12" rx="3" />
                <path d="M18 12h.01" />
              </svg>

              <span className={styles.navLabel}>Wallet</span>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}